import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=106edb2d&"
import script from "./Loader.vue?vue&type=script&lang=js&"
export * from "./Loader.vue?vue&type=script&lang=js&"
import style0 from "./Loader.vue?vue&type=style&index=0&id=106edb2d&prod&lang=scss&"
import style1 from "./Loader.vue?vue&type=style&index=1&id=106edb2d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports